import { Pipe, PipeTransform } from '@angular/core';
import { GridData } from '@shared/models/grid';

@Pipe({
  name: 'filterDropdownOptions',
})
export class FilterDropdownOptionsPipe implements PipeTransform {
  transform(
    data: any[],
    filterFn: (data: any[], rowData?: Partial<GridData>) => any[],
    rowData?: Partial<GridData>
  ): any {
    if (!data?.length) {
      return [];
    }

    if (!filterFn) {
      return data;
    }

    return filterFn(data, rowData);
  }
}
